import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Notification = {
  name: string;
  location: string;
  time: string;
  initials: string;
};
const notifications: Notification[] = [{
  name: 'Camille Laurent',
  location: 'Paris, France',
  time: 'il y a 5 minutes',
  initials: 'CL'
}, {
  name: 'Sophie Martin',
  location: 'Lyon, France',
  time: 'il y a 12 minutes',
  initials: 'SM'
}, {
  name: 'Élodie Dubois',
  location: 'Bruxelles, Belgique',
  time: 'il y a 18 minutes',
  initials: 'ÉD'
}, {
  name: 'Julie Tremblay',
  location: 'Montréal, Canada',
  time: 'il y a 27 minutes',
  initials: 'JT'
}, {
  name: 'Claire Rochat',
  location: 'Genève, Suisse',
  time: 'il y a 41 minutes',
  initials: 'CR'
}];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimer = window.setTimeout(() => setVisible(true), 4500);
    return () => window.clearTimeout(showTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const nextTimer = window.setTimeout(() => {
      setVisible(false);
      window.setTimeout(() => {
        if (!dismissed) {
          setIndex(current => (current + 1) % notifications.length);
          setVisible(true);
        }
      }, 700);
    }, 5000);
    return () => window.clearTimeout(nextTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const notification = notifications[index];
  return <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex w-full -translate-x-1/2 justify-center px-4" data-id="element-221" data-mp="yid1oym0qwf3">
      <AnimatePresence mode="wait" data-id="element-222" data-mp="3ncs8wqi69eny">
        {visible && <motion.div key={notification.name} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-xl border border-brand-line bg-white p-3.5 shadow-soft" data-id="element-223" data-mp="3j93z0162i6zj">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-blush text-sm font-semibold text-brand-deep" data-id="element-224" data-mp="31z01ey0r8yme">
              {notification.initials}
            </span>
            <div className="min-w-0 flex-1" data-id="element-225" data-mp="2s00vvobadj3m">
              <p className="text-xs text-brand-muted" data-id="element-226" data-mp="2x0f4p8kpox2p">
                {notification.location}
              </p>
              <p className="mt-0.5 text-sm leading-5 text-brand-ink" data-id="element-227" data-mp="2j2i5s5iscekv">
                <strong className="font-semibold" data-id="element-228" data-mp="2n2sj638wq79r">{notification.name}</strong> a
                acheté Professeur de Danse Classique Pro
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-medium text-brand-deep" data-id="element-229" data-mp="24f07bovtgg6w">
                <ShoppingBagIcon size={11} aria-hidden="true" data-id="element-230" data-mp="1zhhv9pmi5kuo" /> Achat vérifié ·{' '}
                {notification.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification d’achat" className="self-start rounded text-brand-muted transition-colors duration-150 hover:text-brand-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral" data-id="element-231" data-mp="28g2a2foxzadm">
              <XIcon size={15} data-id="element-232" data-mp="2w80kyykhb3q8" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}